

import { AppConfig } from '../../AppConfig';
import { ApiHelperV2 } from '../helpers/ApiHelperV2';
import { Controller } from '../Controller';

export class UserMgrV2 {
  userFb = null;
  userLocal = null;
  appUser = null;
  userSettings = null;
  defaultUserSettings = AppConfig.userDefaultSettings;
  currUserSettings = null;
  tkn = null;
  currentOrg = null;

  constructor() {
    this.setAppUser();
  }

  updateUserSettings(userSettings) {
    const orgId = this.currentOrg ? this.currentOrg._id : null
    const options = {
      endPoint: ApiHelperV2.makeUrlPath(['users', this.appUser._id, 'settings'], { orgId: orgId }),
      jsonBody: {
        settings: userSettings
      },
      method: 'POST'
    }

    ApiHelperV2.call(options, function (err, data) {
      if (err) {
        const msg = err.message ? err.message : 'An error occurred, please try again. Contact customer care if problem persists.';
        this.setState({
          errMsg: msg,
          errCode: err.respCode,
        })
        return
      } else {
        this.currUserSettings = userSettings
      }
    }.bind(this))
  }

  updateWithDefaultSettings(settings) {
    if (settings) {
      if (settings.ALERT_EMAIL === undefined) {
        settings.ALERT_EMAIL = this.defaultUserSettings.ALERT_EMAIL;
      }
      if (settings.EVENT_VISIBILITY === undefined) {
        settings.EVENT_VISIBILITY = this.defaultUserSettings.EVENT_VISIBILITY;
      }
      if (settings.EVENT_EMAIL_ALERT === undefined) {
        settings.EVENT_EMAIL_ALERT = this.defaultUserSettings.EVENT_EMAIL_ALERT;
      }
      if (settings.CAMERAS === undefined) {
        settings.CAMERAS = this.defaultUserSettings.CAMERAS;
      }
    } else {
      settings = this.defaultUserSettings
    }
    return settings
  }

  setFullScreenMode(fullscreenMode) {
    if (fullscreenMode) {
      localStorage.setItem('fullscreenMode', JSON.stringify('ON'))
    } else {
      localStorage.removeItem('fullscreenMode');
    }
  }

  getFullScreenMode() {
    const fullscreenMode = localStorage.getItem('fullscreenMode')
    if (fullscreenMode) {
      return fullscreenMode
    }
    return null;
  }

  setloggedInUserLocal(user) {
    return new Promise((resolve, reject) => {
      this.userLocal = {
        type: 'local',
        token: user.token
      }
      localStorage.setItem('userLocal', JSON.stringify(this.userLocal))
      let userEndpoint = ApiHelperV2.makeUrlPath(['users', 'me'])
      //console.log('this.currentOrg', this.currentOrg)
      if(this.currentOrg) {
        userEndpoint = ApiHelperV2.makeUrlPath(['users', 'me'], {orgId: this.currentOrg._id})
      }
      const that = this;

      ApiHelperV2.call({ method: 'GET', endPoint: userEndpoint }, function (err, data) {
        if (!err) {
          that.appUser = data.appUser;
          localStorage.setItem('appUser', JSON.stringify(that.appUser))

          that.handleCurrentOrg(that.appUser)

          let settings = {};
          /*if (Object.keys(data.userSettings).length) {
            settings = data.userSettings;
          }*/

          if (data.userSettings && Object.keys(data.userSettings).length) {
            settings = data.userSettings;
          }

          settings = that.updateWithDefaultSettings(settings)
          that.currUserSettings = settings;
          that.updateUserSettings(settings);

          that.setAppUser()

          resolve(true);
        } else {
          reject(err);
        }
      });
    })
  }

  updateCurrentOrg(currentOrg) {
    localStorage.removeItem('currentOrg');
    localStorage.setItem('currentOrg', JSON.stringify(currentOrg))
    this.currentOrg = currentOrg
  }

  handleCurrentOrg(appUser) {
    const currentOrg = localStorage.getItem('currentOrg');
    if (!currentOrg &&
      !this.currentOrg &&
      appUser &&
      appUser.orgs &&
      appUser.orgs.length > 0) {
      localStorage.removeItem('currentOrg');
      localStorage.setItem('currentOrg', JSON.stringify(appUser.orgs[0]))
      this.currentOrg = appUser.orgs[0]
    } else if (currentOrg) {
      this.currentOrg = JSON.parse(currentOrg);
      let orgFound = false
      if (appUser.orgs) {
        for (const org of appUser.orgs) {
          if (org._id === this.currentOrg._id) {
            orgFound = true
            this.currentOrg = org;
            localStorage.removeItem('currentOrg');
            localStorage.setItem('currentOrg', JSON.stringify(org))
            break
          }
        }
      }
      if (!orgFound) {
        localStorage.removeItem('currentOrg');
        this.currentOrg = null
      }
    } else if(appUser && appUser.orgs && appUser.orgs.length > 0 ) {
      localStorage.setItem('currentOrg', JSON.stringify(appUser.orgs[0]))
      this.currentOrg = appUser.orgs[0]
    } else {
      localStorage.removeItem('currentOrg');
      this.currentOrg = null
    }
  }

  setloggedInUserFb(userFb) {
    this.userFb = userFb;

    const userEndpoint = ApiHelperV2.makeUrlPath(['users', 'me'])
    const that = this;

    ApiHelperV2.preAuthAPI(userFb, function (err) {
      //console.log('After preAuthAPI');
      /*if (!err) {
        that.http.get(userEndpoint).pipe(
          catchError(that.apiMgr.handleError))
          .subscribe((data) => {
            that.appUser = data.appUser;
            if (Object.keys(data.userSettings).length) {
              const userSettings = data.userSettings;
              that.userSettings.next(userSettings);
              that.currUserSettings = userSettings;
            } else {
              that.updateUserSettings(that.defaultUserSettings);
            }
          })
      } else {
        that.apiMgr.handlePromiseFailureError(err);
      }*/
    });
  }

  getUser() {
    //console.log("getUser...");
    return this.appUser;
  }

  setAppUser() {
    const appUser = localStorage.getItem('appUser');
    if (appUser && !this.appUser) {
      this.appUser = JSON.parse(appUser);
    }
    const currentOrg = localStorage.getItem('currentOrg');
    if (currentOrg && !this.currentOrg) {
      this.currentOrg = JSON.parse(currentOrg);
    }
  }

  getloggedInUser() {
    const user = this.userFb || this.userLocal;
    if (!user) {
      const userLocal = localStorage.getItem('userLocal')
      if (userLocal) {
        this.userLocal = JSON.parse(userLocal);
        return this.userLocal;
      }
    }
    if (user) {
      //console.log("getloggedInUser type:", user.type||'fib');
    } else {
      //console.log("getloggedInUser:", user);
    }
    return user;
  }

  checkUserPermission(url) {
    if (this.appUser && this.appUser.orgs && this.appUser.orgs.length) {
      if (this.appUser.orgs[0]['_id'] === 'PRODUCT') {
        if (url.startsWith('/admin') || url === '/') {
          return true;
        } else {
          return false;
        }
      } else {
        if (url.startsWith('/admin')) {
          return false;
        } else {
          return true
        }
      }
    }
    return false;
  }

  isProductUser() {
    if (this.appUser && this.appUser.orgs && this.appUser.orgs.length) {
      if (this.appUser.orgs[0]['_id'] === 'PRODUCT') {
        return true
      }
    }
    return false;
  }

  /*isAdminUser() {
    if (this.appUser &&
      this.appUser.systemRoles &&
      this.appUser.systemRoles.length &&
      this.appUser.systemRoles.indexOf('ADMIN') > -1) {
      return true
    }
    return false;
  }*/

  isAdminUser() {
    if (this.currentOrg &&
      this.currentOrg.roles &&
      this.currentOrg.roles.length &&
      this.currentOrg.roles.indexOf('ADMIN') > -1) {
      return true
    }
    return false;
  }

  /*getOrgId() {
    if (this.appUser && this.appUser.orgs && this.appUser.orgs.length) {
      return this.appUser.orgs[0]['_id']
    }
    return null;
  }*/

  getOrgId() {
    if (this.currentOrg && this.currentOrg._id) {
      return this.currentOrg._id
    }
    return null;
  }

  getCurrentOrg() {
    return this.currentOrg
  }

  getUserSettings() {
    //console.log("getUserSettings...");
    if (this.currUserSettings) {
      //console.log("returning current user settings...");
      return this.currUserSettings;
    } else {
      //console.log("returning default user settings")
      return this.defaultUserSettings;
    }
  }

  //handleError(error) {
  //  return observableThrowError(new ApiError(error));
  //}

  /*getProductLogo() {
    if (this.appUser && ('orgs' in this.appUser)) {
      const orgs = this.appUser.orgs
      if (orgs.length > 0) {
        return orgs[0]['logoUrl']
      }
    }
    return null;
  }*/

  getProductLogo() {
    if (this.currentOrg && this.currentOrg.logoUrl) {
      return this.currentOrg.logoUrl
    }
    return null;
  }

  signOut() {
    this.userFb = null;

    this.userLocal = null;
    localStorage.removeItem('userLocal')
    localStorage.removeItem('fullscreenMode');
    localStorage.removeItem('appUser');
    localStorage.removeItem('currentOrg');

    this.appUser = null;
    this.currentOrg = null;
    this.currUserSettings = null;
    Controller.get().pushRoute('/login');
  }

  navigateUserToHome() {
    const home = this.getUserHome();
    Controller.get().pushRoute(home);
  }


  getUserHome() {
    if (this.appUser && this.appUser.orgs && this.appUser.orgs.length) {
      if (this.appUser.orgs[0]['_id'] === 'PRODUCT') {
        return AppConfig.adminDashboard;
      } else {
        return AppConfig.dashboard
      }
    }
    return AppConfig.dashboard; //TODO
  }

  /*getMyOrgId() {
    if (this.appUser && this.appUser.orgs && this.appUser.orgs.length > 0) {
      return this.appUser.orgs[0]['_id'];
    }
  }*/

  getMyOrgId() {
    if (this.currentOrg && this.currentOrg) {
      return this.currentOrg._id;
    }
  }

  getloggedInUserTkn() {
    //console.log("getloggedInUserTkn...");
    if (this.tkn) {
      return this.tkn;
    } else {
      return null;
    }
  }

  setloggedInUserTkn(tkn) {
    //console.log("setloggedInUserTkn...");
    this.tkn = tkn;
  }


}



// WEBPACK FOOTER //
// ./src/common/mgrs/UserMgrV2.js